import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { GetAllRequestResponse } from '@modules/regular-user/requests/domain/entities/requests.entity';
import { createAction, props } from '@ngrx/store';
import {
  Client,
  GetClientsResponse,
  GetMemberResponse,
  Member,
} from '../../domain/entities/clients.entity';

/**
 * Actions For All Clients
 */
export const getAllClientsAction = createAction(
  '[Clients] Get All Clients Action',
  props<{
    companyId: string;
  }>()
);
export const getAllClientsSuccessAction = createAction(
  '[Clients] Get All Clients Success Action',
  props<{
    clients: any;
  }>()
);
export const getAllClientsFailureAction = createAction(
  '[Clients] Get All Clients Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Create Client
 */
export const createClientAction = createAction(
  '[Clients]  Create Client Action',
  props<{
    client: any;
  }>()
);
export const createClientSuccessAction = createAction(
  '[Clients]  Create Client Success Action',
  props<{
    response: any;
  }>()
);
export const createClientFailureAction = createAction(
  '[Clients]  Create Client Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Remove Client
 */
export const removeClientAction = createAction(
  '[Clients] Remove Client Action',
  props<{
    client: string;
  }>()
);
export const removeClientSuccessAction = createAction(
  '[Clients]  Remove Client Success Action',
  props<{
    response: any;
  }>()
);
export const removeClientFailureAction = createAction(
  '[Clients] Remove Client Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Client By Id
 */
export const clientByIdAction = createAction(
  '[Clients] Client By Id Action',
  props<{
    clientId: string;
  }>()
);
export const clientByIdSuccessAction = createAction(
  '[Clients]  Client By Id Success Action',
  props<{
    response: any;
  }>()
);
export const clientByIdFailureAction = createAction(
  '[Clients] Client By Id Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Remove Member
 */
export const removeMemberAction = createAction(
  '[Clients] Remove Member Action',
  props<{
    memberId: string;
  }>()
);
export const removeMemberSuccessAction = createAction(
  '[Clients]  Remove Member Success Action',
  props<{
    response: any;
  }>()
);
export const removeMemberFailureAction = createAction(
  '[Clients] Remove Member Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Member By Id
 */
export const memberByIdAction = createAction(
  '[Clients] Member By Id Action',
  props<{
    memberId: string;
  }>()
);
export const memberByIdSuccessAction = createAction(
  '[Clients]  Member By Id Success Action',
  props<{
    response: any;
  }>()
);
export const memberByIdFailureAction = createAction(
  '[Clients] Member By Id Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update Member
 */
export const updateMemberAction = createAction(
  '[Clients] Update Member Action',
  props<{
    member: Member;
    memberId: string;
  }>()
);
export const updateMemberSuccessAction = createAction(
  '[Clients]  Update Member Success Action',
  props<{
    response: any;
  }>()
);
export const updateMemberFailureAction = createAction(
  '[Clients] Update Member Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Add Member
 */
export const addMemberAction = createAction(
  '[Clients] Add Member Action',
  props<{
    member: Member;
  }>()
);
export const addMemberSuccessAction = createAction(
  '[Clients]  Add Member Success Action',
  props<{
    response: GetMemberResponse;
  }>()
);
export const addMemberFailureAction = createAction(
  '[Clients] Add Member Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Add Multiple Member
 */
export const addMultipleMembersAction = createAction(
  '[Clients] Add Multiple Member Action',
  props<{
    members: Member[];
  }>()
);
export const addMultipleMembersSuccessAction = createAction(
  '[Clients]  Add Multiple Member Success Action',
  props<{
    response: GetMemberResponse;
  }>()
);
export const addMultipleMembersFailureAction = createAction(
  '[Clients] Add Multiple Member Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Update Client
 */
export const updateClientAction = createAction(
  '[Clients] Update Client Action',
  props<{
    client: Client;
    clientId: string;
  }>()
);
export const updateClientSuccessAction = createAction(
  '[Clients] Update Client Success Action',
  props<{
    response: GetClientsResponse;
  }>()
);
export const updateClientFailureAction = createAction(
  '[Clients] Update Client Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Get Pending Request By Member
 */
export const getPendingRequestsByMemberAction = createAction(
  '[Clients] Get Pending Request By Member Action',
  props<{
    member: string;
  }>()
);
export const getPendingRequestsByMemberSuccessAction = createAction(
  '[Clients] Get Pending Request By Member Success Action',
  props<{
    response: GetAllRequestResponse;
  }>()
);
export const getPendingRequestsByMemberFailureAction = createAction(
  '[Clients] Get Pending Request By Member Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Remove And Assign Requests
 */
export const removeAndAssignAction = createAction(
  '[Clients] Remove And Assign Action',
  props<{
    data: {
      _oldApproverId: string;
      _newApproverId: string;
    };
  }>()
);
export const removeAndAssignSuccessAction = createAction(
  '[Clients] Remove And Assign Success Action',
  props<{
    response: GetMemberResponse;
  }>()
);
export const removeAndAssignFailureAction = createAction(
  '[Clients] Remove And Assign Failure Action',
  props<{
    failure: Failure;
  }>()
);

export const ClientsActions = {
  /**
   * Actions For Get All Clients
   */
  getAllClients: getAllClientsAction,
  getAllClientsSuccess: getAllClientsSuccessAction,
  getAllClientsFailure: getAllClientsFailureAction,

  /**
   * Actions For Get Create Client
   */
  createClient: createClientAction,
  createClientSuccess: createClientSuccessAction,
  createClientFailure: createClientFailureAction,

  /**
   * Actions For Remove Client
   */
  removeClient: removeClientAction,
  removeClientSuccess: removeClientSuccessAction,
  removeClientFailure: removeClientFailureAction,

  /**
   * Actions For Client By Id
   */
  clientById: clientByIdAction,
  clientByIdSuccess: clientByIdSuccessAction,
  clientByIdFailure: clientByIdFailureAction,

  /**
   * Actions For Remove Member
   */
  removeMember: removeMemberAction,
  removeMemberSuccess: removeMemberSuccessAction,
  removeMemberFailure: removeMemberFailureAction,

  /**
   * Actions For Member By Id
   */
  memberById: memberByIdAction,
  memberByIdSuccess: memberByIdSuccessAction,
  memberByIdFailure: memberByIdFailureAction,

  /**
   * Actions For Update Member
   */
  updateMember: updateMemberAction,
  updateMemberSuccess: updateMemberSuccessAction,
  updateMemberFailure: updateMemberFailureAction,

  /**
   * Actions For Add Member
   */
  addMember: addMemberAction,
  addMemberSuccess: addMemberSuccessAction,
  addMemberFailure: addMemberFailureAction,

  /**
   * Actions For Add Multiple Member
   */
  addMultipleMembers: addMultipleMembersAction,
  addMultipleMembersSuccess: addMultipleMembersSuccessAction,
  addMultipleMembersFailure: addMultipleMembersFailureAction,

  /**
   * Actions For Update Client
   */
  updateClient: updateClientAction,
  updateClientSuccess: updateClientSuccessAction,
  updateClientFailure: updateClientFailureAction,
  /**
   * Actions For Update Client
   */
  getPendingRequestsByMember: getPendingRequestsByMemberAction,
  getPendingRequestsByMemberSuccess: getPendingRequestsByMemberSuccessAction,
  getPendingRequestsByMemberFailure: getPendingRequestsByMemberFailureAction,
  /**
   * Remove And Assign
   */
  removeAndAssign: removeAndAssignAction,
  removeAndAssignSuccess: removeAndAssignSuccessAction,
  removeAndAssignFailure: removeAndAssignFailureAction,
};
